import { JSONEditor } from '@json-editor/json-editor'
class NestedArrayEnumSourceHelper extends JSONEditor.AbstractEditor {
  build () {
    // this will prevent the value of this editor from being included in the final data
    this.active = false
  }

  setValue () {

  }

  setupSourceArrayWatcher () {
    this.removeCurrentSourceArrayWatcher()

    if (this.sourceEditor) {
      this.watchedSourceArrayPath = this.sourceEditor.path
      this.jsoneditor.watch(this.watchedSourceArrayPath, this.watch_listener)
    }
  }

  removeCurrentSourceArrayWatcher () {
    if (this.watchedSourceArrayPath) {
      this.jsoneditor.unwatch(this.watchedSourceArrayPath, this.watch_listener)
    }
  }

  onWatchedFieldChange () {
    // console.log('NestedArrayEnumSourceHelper: on watched field change')
    // this.sourceEditor = this.getEditorFromPathSegments(this.schema.options.pathSegments, null, 0)
    this.sourceEditor = this.getEditorAtPathSegmentIndex(this.schema.options.pathSegments)
    this.setupSourceArrayWatcher()
    this.notify()
  }

  // This method gets the editor at the specified index of the pathSegments array
  // If the only argument you pass is the pathSegments object, it will ultimately return the editor from the last path segment
  getEditorAtPathSegmentIndex (pathSegments, pathPartIndex = (pathSegments.length - 1), startingEditor, curIndex = 0) {
    let path = ''
    const pathPart = pathSegments[curIndex]
    path += this.getAdjustedPath(pathPart.path, startingEditor, curIndex)
    const editor = this.jsoneditor.getEditor(path)
    if (curIndex === pathPartIndex || !editor) {
      return editor
    }
    const editorValue = editor.getValue()
    if (!Array.isArray(editorValue)) {
      throw new Error(`While parts of the path may contain objects, such as x.y.z, all path parts must ultimately point to an array. ${pathPart.path} does not.`)
    }
    const watchedVals = this.getWatchedFieldValues()
    const arrItemIndex = this.findArrayItemIndex(editorValue, pathPart, watchedVals)
    if (arrItemIndex === -1) {
      return null
    }
    const newPath = `${path}.${arrItemIndex}`
    const itemEditor = this.jsoneditor.getEditor(newPath)
    return this.getEditorAtPathSegmentIndex(pathSegments, pathPartIndex, itemEditor, curIndex + 1)
  }

  findArrayItemIndex (arr, pathPart, watchedVals) {
    if (!Object.hasOwn(watchedVals, pathPart.equalToWatchedProp)) {
      throw new Error(`No watched value exists by the name of ${pathPart.equalToWatchedProp}`)
    }
    const watchValComparator = watchedVals[pathPart.equalToWatchedProp]

    const arrItemIndex = arr.findIndex(item => item[pathPart.itemProp] === watchValComparator)
    if (arrItemIndex === -1) {
      const warnMessage = watchValComparator === '' ? 'an empty string' : watchValComparator
      console.warn(`No item found where item[${pathPart.itemProp}] is equal to ${warnMessage}`)
    }
    return arrItemIndex
  }

  // this code adapted from the setupWatchListeners method in jsonEditor's AbstractEditor class (editor.js in jsonEditor source)
  getAdjustedPath (path, editor, index) {
    editor = editor || this
    const pathSegments = path.split('.')
    if (!this.theme.closest(editor.container, `[data-schemaid="${pathSegments[0]}"]`)) pathSegments.unshift('#')
    let first = pathSegments.shift()
    if (first === '#') first = this.jsoneditor.schema.id || this.jsoneditor.root.formname

    let root
    if (index === 0) {
      root = this.theme.closest(editor.container, `[data-schemaid="${first}"]`)
    } else {
      root = editor.container
    }
    if (!root) throw new Error(`Could not find ancestor node with id ${first}`)

    // adjusted path is the path to the root, plus the path from the root to the editor
    const adjustedPath = `${root.getAttribute('data-schemapath')}.${pathSegments.join('.')}`
    return adjustedPath
  }

  // this is the function called on this editor by other editors to get this editor's value
  getValue () {
    if (!this.sourceEditor) {
      // console.log('no source editor, returning undefined')
      return undefined
    }

    const sourceObj = this.sourceEditor.getValue()

    const val = sourceObj.map((item) => {
      let title = item[this.options.titleProp]
      if (title.length > 30) {
        title = `${title.substring(0, 30)}...`
      }
      return {
        value: item[this.options.valueProp],
        title: `${item[this.options.valueProp]}: ${title}`
      }
    })

    return val
  }

  // taken from AbstractEditor (editor.js in jsonEditor source) adding code to unwatch the watchedSourceArrayPath
  destroy () {
    this.unregister(this)
    if (this.watched) {
      Object.values(this.watched).forEach(adjustedPath => this.jsoneditor.unwatch(adjustedPath, this.watch_listener))
    }

    if (this.watchedSourceArrayPath) {
      this.jsoneditor.unwatch(this.watchedSourceArrayPath, this.watch_listener)
    }

    this.watched = null
    this.watched_values = null
    this.watch_listener = null
    this.header_text = null
    this.header_template = null
    this.value = null
    if (this.container && this.container.parentNode) this.container.parentNode.removeChild(this.container)
    this.container = null
    this.jsoneditor = null
    this.schema = null
    this.path = null
    this.key = null
    this.parent = null
  }
}

export default NestedArrayEnumSourceHelper
